import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@showroom.local");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white grid place-items-center px-6 dot-grid relative">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-slate-950 to-slate-950 pointer-events-none" />
      <Card className="relative w-full max-w-md p-8 rounded-2xl bg-slate-900 border-white/10 text-white" data-testid="login-card">
        <div className="w-12 h-12 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] grid place-items-center">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="mt-5 font-heading text-3xl font-bold tracking-tight">Admin Sign In</h1>
        <p className="text-slate-400 text-sm mt-2">Manage systems, credentials, and lead inbox.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="email" className="text-slate-300">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-slate-800 border-white/10 text-white" data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-300">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-slate-800 border-white/10 text-white" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#D4AF37] text-slate-900 hover:bg-[#F3CE52] font-semibold h-11" data-testid="login-submit-button">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
